import {EntityData, field} from "@fedeltapointofsale/data-client";

export class AddressData extends EntityData<AddressData> {
    @field street: string;
    @field city: string;
    @field state: string;
    @field postCode: string;
    @field country: string;
}
